import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Gem: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M6 3h12l4 6-10 13L2 9Z' }],
    ['path', { d: 'M11 3 8 9l4 13 4-13-3-6' }],
    ['path', { d: 'M2 9h20' }],
  ],
];

export default Gem;
